export default __webpack_public_path__ + "static/media/primogem.67e60555.png";